/**
 * ARTIST CNTRL PRO's five touring PARTIES (ART-144) — the CLIENT's half, which is labels and order and
 * nothing else.
 *
 * **There is no `partyOf` here, deliberately.** The resolution — seat override, else the title's default,
 * else C Party — lives on the server (`core.crew_party` / `CrewParties.Resolve`) and arrives on the row as
 * `seat.party`. A client-side copy would be a second implementation of a displayed rule, which is the defect
 * `TopCityRow.Action` was written to close: two surfaces gave contradictory advice off identical figures and
 * nothing looked broken. Render what the server resolved.
 *
 * The keys are the wire's and legacy's (`ProTeam`); only the LABELS say "Party", because *Your Teams* on this
 * very page already means the linked label / management / booking orgs (PO, 2026-09-10).
 */
export const CREW_PARTIES = [
  { key: "a", label: "A Party" },
  { key: "b", label: "B Party" },
  { key: "c", label: "C Party" },
  { key: "production", label: "Production Office" },
  { key: "drivers", label: "Drivers" },
] as const;

export type CrewParty = (typeof CREW_PARTIES)[number]["key"];

/** Production Office: the party that may MOVE people, and the one exempt from the contact narrowing. */
export const PRODUCTION_OFFICE: CrewParty = "production";

const LABELS: Record<string, string> = Object.fromEntries(CREW_PARTIES.map((p) => [p.key, p.label]));

/**
 * A party's label. Falls back to the raw key rather than to empty, on the `roleLabelFrom` rule: a pill that
 * renders NOTHING for an unrecognised value is indistinguishable from a person with no party, and the party
 * vocabulary can only grow by migration — so an unknown key here means the client is behind the server, which
 * is worth seeing rather than hiding.
 */
export function crewPartyLabel(party: string | null | undefined): string {
  if (!party) return "";
  return LABELS[party] ?? party;
}
